import React from 'react';
import PropTypes from 'prop-types';

const NO_SEARCH_RESULTS_MESSAGE = 'No search results!';
const CREATE_CUSTOM_QUESTION_MESSAGE = 'Create a custom question to get started!';
const QUESTION_AVAILABILITY_MESSAGE = 'It will be available here for your next event.';

const baseClassName = 'FormTemplateCustomInfoMessage';

const FormTemplateCustomInfoMessage = ({ customSearchTerm }) => (
    <aside className={`${baseClassName}-empty`}>
        <figure className={`${baseClassName}-empty-illustration`} />
        {customSearchTerm ? (
            <p>{NO_SEARCH_RESULTS_MESSAGE}</p>
        ) : (
            <div>
                <p>{CREATE_CUSTOM_QUESTION_MESSAGE}</p>
                <p>{QUESTION_AVAILABILITY_MESSAGE}</p>
            </div>
        )}
    </aside>
);

FormTemplateCustomInfoMessage.propTypes = {
    customSearchTerm: PropTypes.string,
};

FormTemplateCustomInfoMessage.defaultProps = {
    customSearchTerm: null,
};

export default FormTemplateCustomInfoMessage;
